import '|/app.styl';
import '|/../sass/app.scss';
//import _ from 'lodash';

// Scripts
import Admin from './Admin';
import Countdown from './Countdown';
import IntoView from './IntoView';
import MatchHeight from './MatchHeight';
import SmoothScroll from './SmoothScroll';
import Dismiss from './Dismiss';
import Overflow from './Overflow';

// Vendors
import Hamburger from './Vendor/Hamburger';
import Map from './Vendor/Google/Map';
import Parallax from './Vendor/Parallax';
import SlickSlider from './Vendor/SlickSlider';
import Sticky from './Vendor/Sticky';
import Bootstrap from './Vendor/Bootstrap';
import Masonry from './Vendor/Masonry';

(function ($) {

    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    $(document).ready(function () {

        // Initialize our maps
        $('.google-map.block .map').each(function (e) {

            // Mapify that bad boy
            new Map($(this));

        });

        // Run our utility scripts
        new Admin();
        new Countdown();
        new IntoView();
        new SmoothScroll();
        new MatchHeight();
        new Dismiss();
        new Overflow();

        // Run our vendor scripts
        new Hamburger();
        new Parallax();
        new SlickSlider();
        new Sticky();
        new Bootstrap();
        new Masonry();

    });

})(jQuery);